module.exports = __webpack_public_path__ + "images/application/i-fullscreen-69886a04.svg";